//import { PlaylistApi } from 'www/modules/video/playlist/playlist-api';
import { PlaylistItem } from './playlist-item';

import { getImageServer } from 'www/utils/get-image-server';
class Playlist {
    constructor(items = [], SVP, theme = "", sticky) {
        //this.api = new PlaylistApi(items);
        this.items = items;
        this.SVP = SVP;
        let el = document.createElement('div');
        el.classList.add('recap-playlist-module');
        if(theme == "dark"){
        	el.classList.add("theme-dark");
        }
        this.el = el;
        this.subscriptions = [];
        this.sticky = sticky;

    }
    get playlistItems() {
        let { SVP, sticky } = this;
        return this.items.map(item => {
            let { playlist } = item;
            return new PlaylistItem(item,SVP, sticky)

        })
    }

    create() {
        return new Promise((resolve, reject) => {
            try {
                this.render();
                resolve(this);
            } catch (e) {
                reject(e);
            }
        });
    }

    render() {
        this.playlistItems.forEach(item => {
            this.el.appendChild(item.el);
            item.init();
        })
    }
}



export { Playlist }